import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-0 rounded right-0 top-0 overflow-y-auto overflow-x-hidden z-index fixed flex flex-col scrollable-container w-full max-w-xl bg-white h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "header", {}, undefined, true),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "border-b border-solid mx-4 border-lightgrey" }, null, -1)),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "opacity-40 fixed inset-0 z-50 bg-black" }, null, -1))
  ], 64))
}